import { CSS } from '../_app/cuchillo/utils/CSS';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import BezierEasing from 'bezier-easing'

class VSliderImage {
  static selector = "data-scroll-slider-image"
  static isNativeAllowed = true;
  static easing = BezierEasing(0.84, 0.31, 0.22, 0.54);
  item;
  axis;
  scale0;
  scale1;
  scale2;
  offset;
  x;
  y;
  z;
  width;

  constructor(__item) {
    this.item = __item;
    this.axis = "x";

    this.scale1 = this.item.getAttribute("data-end") !== null ? Number(this.item.getAttribute("data-end")) : 1;
    this.scale0 = this.item.getAttribute("data-start") !== null ? Number(this.item.getAttribute("data-start")) : 1.2;
    this.scale2 = 1.1;
    this.width = this.item.width;

    const TRANSLATE = CSS.getTranslate(this.item);
    this.x = TRANSLATE.x;
    this.y = TRANSLATE.y;
    this.z = this.item.style.zIndex || 0;

    this.offset = this.item.offsetLeft;
  }

  loop(__position, __progress, __progressInside) {
    const POS = this.axis === "x" ? __position.x : __position.y;
    const PROGRESS = Maths.normalize(0, this.width, POS);
    const ALPHA = Maths.normalize(0, -this.width, POS);

    if (POS > 0) {
      const scale = Maths.lerp(this.scale0, this.scale1, VSliderImage.easing(PROGRESS));
      this.item.style[CSS.transform] = CSS.translate3D(this.x, this.y, this.z) + " " + CSS.scale3D(scale, scale);
    } else {
      const scale = Maths.lerp(this.scale1, this.scale2, VSliderImage.easing(PROGRESS - 1));

      this.item.style[CSS.transform] = CSS.translate3D(POS * -.3, this.y, this.z) + " " + CSS.scale3D(scale, scale);
      this.item.style.opacity = ALPHA + .5;
    }
  }

  dispose() { };

  resize(__size) {
    this.width = this.item.offsetWidth;
  }
}

Scroll._registerInsider(VSliderImage);

